/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Join_RequestsInputs */

const en_join_requests = /** @type {(inputs: Join_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Requests`)
};

const es_join_requests = /** @type {(inputs: Join_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes de Unión`)
};

const fr_join_requests = /** @type {(inputs: Join_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demandes d'adhésion`)
};

const de_join_requests = /** @type {(inputs: Join_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrittsanfragen`)
};

const id_join_requests = /** @type {(inputs: Join_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan Bergabung`)
};

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const ja_join_requests = en_join_requests;

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const zh_join_requests = en_join_requests;

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const ar_join_requests = en_join_requests;

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const it_join_requests = en_join_requests;

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const ru_join_requests = en_join_requests;

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const pt_join_requests = en_join_requests;

/** @type {(inputs: Join_RequestsInputs) => LocalizedString} */
const ko_join_requests = en_join_requests;

/**
* | output |
* | --- |
* | "Join Requests" |
*
* @param {Join_RequestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const join_requests = /** @type {((inputs?: Join_RequestsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_RequestsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_join_requests(inputs)
	if (locale === "es") return es_join_requests(inputs)
	if (locale === "fr") return fr_join_requests(inputs)
	if (locale === "de") return de_join_requests(inputs)
	if (locale === "ja") return ja_join_requests(inputs)
	if (locale === "zh") return zh_join_requests(inputs)
	if (locale === "ar") return ar_join_requests(inputs)
	if (locale === "id") return id_join_requests(inputs)
	if (locale === "it") return it_join_requests(inputs)
	if (locale === "ru") return ru_join_requests(inputs)
	if (locale === "pt") return pt_join_requests(inputs)
	return ko_join_requests(inputs)
});